import React from 'react';
import {NavigationContainer, LinkingOptions} from '@react-navigation/native';
import {StatusBar, useColorScheme} from 'react-native';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {Routes, RootNavigatorParams, screenLinking} from './Routes';
// import {InsideStack} from './stacks/InsideStack';
import {OutSideStack} from './stacks/OutSideStack';
import {displayScreenTitle} from 'constants/DefaultValues';
// import {useSelector} from 'react-redux';
// import {authStatus, checkPasswordUpdated} from 'redux/selectors/authSelector';
// import {ResetPasswordScreen} from 'screens/auth-screen';
const Stack = createNativeStackNavigator();

// Define the parameter list for your navigator

export const RootNavigator: React.FC = () => {
  const isDarkMode = useColorScheme() === 'dark';
  // const isAuthenticated = false;
  // const isPasswordUpdated = useSelector(checkPasswordUpdated);
  const linking: LinkingOptions<RootNavigatorParams> = {
    prefixes: ['https://1idp.com'],
    config: {
      screens: screenLinking,
    },
  };

  // const ProtectedStacks = !isPasswordUpdated ? (
  //   <Stack.Screen
  //     name={Routes.RESET_PASSWORD_FIRST}
  //     options={{headerShown: displayScreenTitle}}
  //   >
  //     {props => <ResetPasswordScreen mode='reset' {...props}/>}
  //   </Stack.Screen>
  // ) : (
  //   <Stack.Screen
  //     name={Routes.INSIDE_STACK}
  //     component={InsideStack}
  //     options={{headerShown: displayScreenTitle}}
  //   />
  // );

  return (
    <NavigationContainer linking={linking}>
      <StatusBar barStyle={isDarkMode ? 'light-content' : 'dark-content'} />
      <Stack.Navigator>
        {/* {isAuthenticated ? (
          ProtectedStacks
        ) : ( */}
          <Stack.Screen
            name={Routes.OUTSIDE_STACK}
            component={OutSideStack}
            options={{headerShown: displayScreenTitle}}
          />
        {/* )} */}
      </Stack.Navigator>
    </NavigationContainer>
  );
};
